<script>
export default {
  name: "ba7-get-started",
  props: ['view'],
  data() {
    return {
      t: null,
      defaultChallenges: null,
      challenges: null,
      loading: true,
      allDone: false,
      allDoneOptions: {}
    }
  },
  created() {
    this.t = this.view.translations
    this.getChallenges()
    this.allDoneOptions = [
      {
        text: this.t.browse_website_template,
        action: {
          target: '_self',
          action: this.view.routes.upgrade_website_builder == null
                  ? (this.view.routes.website_builder + '?redirect_url='+encodeURIComponent('/create-website?step=template'))
                  : this.view.routes.upgrade_website_builder
        }
      },
      {
        text: this.t.set_up_your_first_email,
        action: {
          target: '_self',
          action: this.view.routes.upgrade_mailingboss == null
                  ? (this.view.routes.mailingboss + '?redir='+encodeURIComponent('/customer/campaigns'))
                  : this.view.routes.upgrade_mailingboss
        }
      },
      {
        text: this.t.create_a_course,
        action: {
          target: '_self',
          action: this.view.routes.upgrade_elearning == null
                  ? this.view.routes.elearning
                  : this.view.routes.upgrade_elearning
        }
      },
      {
        text: this.t.create_a_booking_calendar,
        action: {
          target: '_self',
          action: this.view.routes.upgrade_booking == null
                  ? this.view.routes.booking
                  : this.view.routes.upgrade_booking
        }
      },
    ]
  },
  methods: {
    getChallenges() {
      this.loading = true

      const headers = {
        Accept: 'application/json',
        Authorization: this.view.token
      };

      axios.get(`${this.view.routes.office_api}/v1/challenges/DASHBOARD`, {
        headers: headers
      })
        .then(async (response) => {
          this.defaultChallenges = response.data.data.challenges
          if (!isEmpty(response.data.data.challenges)) {
            await this.validateChallengesWithStorage(response.data.data.challenges)
            this.generateChallenges()
          } else {
            this.allDone = true
          }
        })
        .catch(error => {
          console.error('builderallChallenges', error)
        })
        .finally(() => {
          this.loading = false
          this.defineStyleToChallenges()
        })
    },
    defineStyleToChallenges(){
      const container = document.querySelector('.ba-content.ba7-challenges-list')

      container.style.justifyContent = 'flex-start';
      if (this.challenges && this.challenges.length > 3) {
        container.style.justifyContent = 'space-between'
      }
    },
    bypassChallenge(slug, action) {
      this.loading = true

      const headers = {
        Authorization: this.view.token
      };

      const bypassedChallenges = JSON.parse(sessionStorage.getItem('bypassedChallenges')) || [];

      if (!bypassedChallenges.includes(slug)) {
        bypassedChallenges.push(slug);
        sessionStorage.setItem('bypassedChallenges', JSON.stringify(bypassedChallenges));
      }

      fetch(`${this.view.routes.office_api}/v1/challenges/${slug}/${action}`, {
        method: 'POST',
        headers: headers
      })
        .then(response => response.json())
        .then(result => {
          if (result.success) {
            alertMsg('success', result.message)
          }
        })
        .catch(error => {
          console.error('builderallChallengeBypass', error)
          this.loading = false
        })
        .finally(() => {
          this.getChallenges()
          this.defineStyleToChallenges()
        })
    },
    validateChallengesWithStorage(challenges) {
      const bypassedChallenges = JSON.parse(sessionStorage.getItem('bypassedChallenges')) || [];

      const updatedChallenges = challenges.map(challenge => {
        if (bypassedChallenges.includes(challenge.slug)) {
          return { ...challenge, is_bypassed: true, is_completed: true };
        }
        return challenge;
      });

      this.allDone = updatedChallenges.every(x => x.is_completed)
      this.defaultChallenges = updatedChallenges
    },
    generateChallenges() {
      const bypassedChallenges   = JSON.parse(sessionStorage.getItem('bypassedChallenges')) || [];
      const completedChallenges  = this.defaultChallenges.filter(challenge => challenge.is_completed && !challenge.is_bypassed && !bypassedChallenges.includes(challenge.slug));
      const incompleteChallenges = this.defaultChallenges.filter(challenge => !challenge.is_completed && !challenge.is_bypassed && !bypassedChallenges.includes(challenge.slug));

      let selectedCompleted = incompleteChallenges.length === 1
                              ? completedChallenges.slice(-3)
                              : completedChallenges.slice(-2);

      const remainingSlots     = 4 - selectedCompleted.length;
      const selectedIncomplete = incompleteChallenges.slice(0, remainingSlots);

      this.challenges = [...selectedCompleted, ...selectedIncomplete].slice(0, 4);
    },
    open(action) {
      window.open(action.action, action.target)
    }
  },
}
</script>

<template>
  <div class="ba7-get-started">
    <builderall-loader :loading="loading">
      <div class='ba-card'>
        <div class='ba-top'>
          <div class='ba-flex ba-f-column'>
            <span class='ba-title' style="font-size: 15.99px">{{ allDone ? t.get_more_from_builderall_ms_title : t.get_started_builderall_ms_title }}</span>
          </div>
        </div>
        <div class='ba-content ba7-challenges-list'>
          <span v-show="!allDone" class='ba-subtitle'>{{ t.get_started_builderall_ms_description }}</span>
          <div v-if="allDone"
               class="finished-challenges all-done ba-mg-t-1"
          >
            <section
              v-for="(option, i) in allDoneOptions"
              :key="i"
              class="ba-grid ba-w-100"
              @click="open(option.action)"
            >
              <div class="ba-grid ba-ai-center all-done-info">
                <div class="ba-flex ba-f-column">
                  <span>{{ option.text }}</span>
                </div>
                <builderall-icon code="arrow-right" style="--builderall-icon-color: #0072E1;"></builderall-icon>
              </div>
            </section>
          </div>
          <div v-else
               v-for="(x, i) in challenges"
               :class="{'card-tutorial': true, 'concluded': x.is_completed, 'not-full': challenges.length < 4 }"
               :key="x.slug"
          >
            <div class="remove-tutorial"
                 @click="bypassChallenge(x.slug, 'bypass')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                <g clip-path="url(#clip0_5571_3322)">
                  <rect width="26" height="26" rx="13" fill="#FF3636" fill-opacity="0.1"/>
                  <path d="M19.8253 6.18583C19.4028 5.76333 18.7203 5.76333 18.2978 6.18583L13.0003 11.4725L7.70277 6.175C7.28027 5.7525 6.59777 5.7525 6.17527 6.175C5.75277 6.5975 5.75277 7.28 6.17527 7.7025L11.4728 13L6.17527 18.2975C5.75277 18.72 5.75277 19.4025 6.17527 19.825C6.59777 20.2475 7.28027 20.2475 7.70277 19.825L13.0003 14.5275L18.2978 19.825C18.7203 20.2475 19.4028 20.2475 19.8253 19.825C20.2478 19.4025 20.2478 18.72 19.8253 18.2975L14.5278 13L19.8253 7.7025C20.2369 7.29083 20.2369 6.5975 19.8253 6.18583Z" fill="#FF3636"/>
                </g>
                <defs>
                  <clipPath id="clip0_5571_3322">
                    <rect width="26" height="26" rx="13" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="tutorial-section"
                 @click="open(x.action)"
            >
              <svg v-if="!x.is_completed" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM13.88 6.29L8 12.17L6.12 10.29C5.73 9.9 5.1 9.9 4.71 10.29C4.32 10.68 4.32 11.31 4.71 11.7L7.3 14.29C7.69 14.68 8.32 14.68 8.71 14.29L15.3 7.7C15.69 7.31 15.69 6.68 15.3 6.29C14.91 5.9 14.27 5.9 13.88 6.29Z" fill="#C4D1E0"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path d="M10.3743 0C4.97761 0 0.597656 4.48 0.597656 10C0.597656 15.52 4.97761 20 10.3743 20C15.7711 20 20.151 15.52 20.151 10C20.151 4.48 15.7711 0 10.3743 0ZM7.72485 14.29L4.21503 10.7C3.83374 10.31 3.83374 9.68 4.21503 9.29C4.59632 8.9 5.21225 8.9 5.59354 9.29L8.419 12.17L15.1453 5.29C15.5266 4.9 16.1426 4.9 16.5239 5.29C16.9052 5.68 16.9052 6.31 16.5239 6.7L9.10336 14.29C8.73185 14.68 8.10614 14.68 7.72485 14.29Z" fill="white"/>
              </svg>
              <div class="tutorial-info ba-flex ba-f-column">
                <span class="ba-title">{{ x.title }}</span>
              </div>
              <builderall-icon v-show="!x.is_completed" code='arrow-right' />
            </div>
          </div>
        </div>
      </div>
    </builderall-loader>
  </div>
</template>

<style scoped lang="scss">
.ba7-get-started {
  width: 100%;
  height: 100%;
  .ba-card {
    height: 100%;
    .ba-subtitle {
      color: #425E7D;
    }
    .ba-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 16px;

      .finished-challenges {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 35px;

        span {
          color: #425E7D;
          text-align: center;
          font-family: Mulish;
          font-size: 16px;
          font-weight: 700;
          width: 74%;
        }
      }
      .all-done {
        gap: 16px;
        justify-content: flex-start;

        section {
          grid-template-columns: 1fr;
          min-height: 60px;
          cursor: pointer;

          .all-done-info {
            grid-template-columns: 1fr 50px;
            -webkit-box-align: center;
            border-radius: 8px;
            padding: 8px 0 8px 12px;
            border: 1px solid #c4d1e0;
            transition: border 0.4s ease;

            span {
              color: #4D5D71;
              font-weight: normal;
              text-align:left;
              transition: border 0.4s ease;
            }
          }

          &:hover {
            .all-done-info {
              border-radius: 8px;
              border: 1px solid #0072E1;

              span {
                color: #0072E1;
              }
            }
          }
        }
      }
      .card-tutorial {
        display: grid;
        grid-template-columns: 0fr 1fr;
        width: 100%;
        min-height: 60px;
        transition: grid-template-columns 0.5s ease;
        cursor: pointer;

        .remove-tutorial {
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          transition: background-color 0.3s ease;
        }
        .tutorial-section {
          display: grid;
          grid-template-columns: 35px 1fr 50px;
          align-items: center;
          gap: 14px;
          border-radius: 8px;
          border: 1px solid #C4D1E0;
          transition: border 0.3s ease;
          padding: 8px 0 8px 12px;
          .tutorial-info {
            .ba-title {
              color: #4D5D71;
              font-weight: 700;
              padding: 0 !important;
            }
          }
        }
        builderall-icon{
          --builderall-icon-color: rgba(0, 114, 225, 1);
        }
        &.concluded {
          .tutorial-section {
            background-color: #1AD9A9;
            border: 1px solid #1AD9A9;
          }
          span {
            color: #ffffff !important;
          }
        }
        &:not(.concluded):hover {
          grid-template-columns: .1fr 1fr;
          .tutorial-section {
            border: 1px solid #0072E1;
            .ba-title {
              color: #0072E1;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/get-started/index.vue